import * as defaultImport from "@splunk/react-ui/WaitSpinner";
export * from "@splunk/react-ui/WaitSpinner";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
